// Financials unlock-session storage — sessionStorage, deliberately:
//  - survives the full-page Intuit OAuth redirect (in-memory would not)
//  - dies with the tab (localStorage would defeat the walked-away-computer
//    scenario, since Firebase auth itself persists indefinitely)
// The SERVER clock is authoritative (finSessions/{uid}.expiresAt); the local
// expiry check just avoids doomed calls, with a 30s skew margin. Any
// FIN_LOCK_REQUIRED from a callable clears storage and re-shows the gate.
const KEY = "fin.unlock.v1";
const SKEW_MS = 30_000;

export const getUnlock = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.expiresAt) return null;
    if (Date.now() >= parsed.expiresAt - SKEW_MS) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return parsed; // { token, expiresAt }
  } catch {
    return null;
  }
};

export const setUnlock = (token, expiresAt) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ token, expiresAt }));
  } catch {
    // Storage unavailable (private mode edge) — the app still works for this
    // page view via state; the user just re-enters the passphrase more often.
  }
};

export const clearUnlock = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
};
